import React from 'react';

import cn from 'classnames';
import pluralize from 'pluralize';
import { func, number, shape, arrayOf, string } from 'prop-types';

import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons/faCircleExclamation';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';

import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';

import Tooltip from 'components/Common/Tooltip';

import s from './MatchResultsBox.css';

const NamesCount = ({ count, onClick }) => (
  <Tooltip title={onClick ? 'Copy List' : ''}>
    <span
      className={cn(s.countValue, { [s.clickable]: onClick })}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      {count} {pluralize('name', count)}
    </span>
  </Tooltip>
);

NamesCount.propTypes = {
  count: number.isRequired,
  onClick: func,
};

NamesCount.defaultProps = {
  onClick: undefined,
};

const MatchResultsBox = props => {
  const {
    data: { matchedCount, notMatchedList, duplicateList },
    actions: { copyList },
  } = props;
  const notMatchedCount = notMatchedList?.length ?? 0;
  const duplicateCount = duplicateList?.length ?? 0;
  return (
    <div className={s.root}>
      {matchedCount > 0 ? (
        <div className={s.row}>
          <div className={s.iconContainer}>
            <FontAwesomeIcon icon={faCircleCheck} color="green" />
          </div>
          <div className={s.content}>
            <NamesCount count={matchedCount} /> with matches applied to filter
          </div>
        </div>
      ) : null}
      {notMatchedCount > 0 || duplicateCount > 0 ? (
        <div className={s.row}>
          <div className={s.iconContainer}>
            <FontAwesomeIcon icon={faCircleExclamation} color="red" />
          </div>
          {notMatchedCount > 0 ? (
            <div className={s.content}>
              <NamesCount
                count={notMatchedCount}
                onClick={() => {
                  copyList(notMatchedList);
                }}
              />{' '}
              with no matches
            </div>
          ) : null}
          {notMatchedCount > 0 && duplicateCount > 0 ? (
            <span className={s.joiner}> and </span>
          ) : null}
          {duplicateCount > 0 ? (
            <div className={s.content}>
              <NamesCount
                count={duplicateCount}
                onClick={() => {
                  copyList(duplicateList);
                }}
              />{' '}
              matches not included in filtered results
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

const MatchResultsBoxDataPropTypes = {
  matchedCount: number.isRequired,
  notMatchedList: arrayOf(string).isRequired,
  duplicateList: arrayOf(string).isRequired,
};

const MatchResultsBoxActionsPropTypes = {
  copyList: func.isRequired,
};

MatchResultsBox.propTypes = {
  data: shape(MatchResultsBoxDataPropTypes).isRequired,
  actions: shape(MatchResultsBoxActionsPropTypes).isRequired,
};

export default MatchResultsBox;
